import { useState, useEffect } from "react";
import styled from "styled-components";
import colors from "../../utils/style/colors";
import FormEntreprise from "../../components/Formulaires/FormEntreprise";
import FormContact from "../../components/Formulaires/FormContact";
import removeCross from "../../assets/images/icones/removeCross.png";

const Modal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;

    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
`;

const ModalContainer = styled.div`
    position: absolute;
    background: black;
    color: white;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    width: ${({ content }) => (content === "suppr" ? "500px" : "auto")};
    height: ${({ content }) => (content === "suppr" ? "350px" : "auto")};
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
        font-size: 1.4rem;
        margin: 30px;
        /* color: ${colors.tertiary} */
    }
    h2 {
        color: ${colors.primary};
        margin: 5px;
    }
    select {
        font-size: 1.3rem;
        font-weight: bold;
        padding: 10px;
        margin: 10px;
        border-radius: 5px;
    }
    .nameSuppr {
        color: ${colors.tertiary};
        font-size: 1.6rem;
        font-weight: bold;
    }

    .red {
        color: rgb(249, 64, 64);
        font-weight: bold;
        font-size: 1.4rem;
        padding: 15px 0;
    }
    .yellow {
        color: ${colors.primary};
    }
    .containerOG {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 1.2rem;
        padding: 15px;
        label {
            padding: 5px;
        }
        .labelOG {
            font-size: 1.4rem;
            padding: 15px;
        }
        input {
            padding: 5px;
            border-radius: 8px;
            text-align: center;
        }
    }
    .listFiles {
        display: flex;
        justify-content: center;
        align-items: bottom;
        gap: 15px;
    }
    .listFiles img {
        border: 1px solid white;
        margin: 0 3px;
        cursor: pointer;
        transform: translateY(3px);
        width: 20px;
    }
    .fileSelector {
        border: 2px solid white;
        padding: 5px;
        border-radius: 5px;
        color: ${colors.secondary};
        cursor: pointer;
    }
    .messUpLoad {
        color: red;
        font-size: 1.3rem;
        margin: 3px;
    }
`;
const Formulaire = styled.form`
    display: flex;
    flex-direction: column;
    .rowMP {
        display: flex;
        justify-content: center;
        gap: 15px;
        margin: 10px;
    }
    .rowMP > label {
        display: flex;
        align-items: center;
    }
    .doc {
        margin-bottom: 10px;
    }
    input {
        padding: 5px;
        text-align: center;
        font-weight: bold;
    }

    select {
        padding: 0;
    }

    .radio {
        display: flex;
        justify-content: center;
        text-align: start;
        margin-bottom: 20px;
        label {
            margin: 0 10px;
        }
        div {
            width: 40%;
        }
    }
    .formCard {
        border: 1px solid ${colors.primary};
        padding: 10px 10px;
        margin-top: 15px;
        border-radius: 10px;
    }

    .fileSelector {
        border: 2px solid white;
        padding: 5px;
        border-radius: 5px;
        color: ${colors.secondary};
        cursor: pointer;
    }
   
  
`;

const ChoiceButtons = styled.div`
    .btnModal {
        padding: 10px 15px;
        border-radius: 4px;
        border: none;
        margin: 10px;
        color: #fff;
        cursor: pointer;
    }
    .btnModal1 {
        background-color: #007bff;
    }
    .btnModal2 {
        background-color: rgb(249, 64, 64);
    }
`;

const ModalProjet = ({
    content,
    type,
    handleClose,
    listContact,
    listOA,
    dataProjet,
    setRefreshFlag,
}) => {
    const statutLabels =
        type === "offre"
            ? {
                  EC: { statut: "EC", label: "En cours/Bloquée" },
                  AR: { statut: "AR", label: "Offre à relancer" },
                  OA: { statut: "OA", label: "Offre annulée" },
                  OP: { statut: "OP", label: "Offre perdue" },
                  OG: { statut: "OG", label: "Offre gagnée" },
              }
            : {
                  OG: { statut: "OG", label: "Offre gagnée" },
                  PR: { statut: "PR", label: "Phase de réalisation" },
                  PA: { statut: "PA", label: "Projet achevé" },
              };

    // const moneyFormat = new Intl.NumberFormat("ci-CI", {
    //     maximumFractionDigits: 2,
    //     minimumFractionDigits: 2,
    // }); affichage seulement....

    const [selectedReferent, setSelectedReferent] = useState(
        dataProjet?.contactId
    );
    const [selectedStatut, setSelectedStatut] = useState(dataProjet?.statut);

    const [messUpLoad, setMessUpLoad] = useState("");

    const [nouvelleOffre, setNouvelleOffre] = useState({
        nom: "",
        dateEtape: "",
        entrepriseId: "",
        entrepriseNom: "",
        contactId: "",
        files: [],
        montant: "",
    });
    // données pour les formulaires Entreprises et Contact
    const [messageError, setMessageError] = useState("");
    const [dataEntreprise, setDataEntreprise] = useState({
        antenne_enea: "",
        nom: "",
        cat: "C",
        adresse: "",
        CP: "",
        ville: "",
    });
    const [dataContact, setDataContact] = useState({
        antenne_enea: "",
        nom: "",
        prenom: "",
        sexe: "",
        entreprise: "",
        fonction: "",
        tel1: "",
        tel2: "",
        mail1: "",
        mail2: "",
        adresse: "",
        CP: "",
        ville: "",
    });

    // mise à jour du dataContact à créer avec l'entreprise choisie (si dataEntreprise change la donnée Entreprise pour le Contact change ici!!)
    useEffect(() => {
        setDataContact((prevState) => ({
            ...prevState, // Conservez les autres propriétés de l'objet
            antenne_enea: dataEntreprise.antenne_enea,
        }));
    }, [dataEntreprise.antenne_enea, dataContact.antenne_enea]);

    const [listEntreprise, setListEntreprise] = useState([]);

    const [listContactRef, setListContactRef] = useState([]);

    const [selectedForm, setSelectedForm] = useState("");
    const [selectedTypeForm, setSelectedTypeForm] = useState("");

    const [selectedOA, setSelectedOA] = useState("");

    const prepareListEntreprise = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(`${apiUrl}/api/admin/entreprise`, {
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();

            if (!response.ok) {
                console.error("Erreur de chargement des entreprises" + data);
            } else {
                setListEntreprise(data);
            }
        } catch (error) {
            console.error(
                "Erreur lors de la récupération des entreprises",
                error
            );
        }
    };

    useEffect(() => {
        prepareListEntreprise();
        // montage de la modaleProjet
        // setNouvelleOffre((prevState) => ({
        //     ...prevState, // Conservez les autres propriétés de l'objet
        //     contactId: "", // Mettez à jour uniquement `contactId`
        // }));
    }, []);

    useEffect(() => {
        const prepareListContactByEnt = async () => {
            if (
                // nouvelleOffre.entrepriseId !== "choix" &&
                nouvelleOffre.entrepriseId !== ""
            ) {
                try {
                    const apiUrl = process.env.REACT_APP_API_URL;
                    const response = await fetch(
                        `${apiUrl}/api/admin/contactsByEntrepriseId/${nouvelleOffre.entrepriseId}`,
                        {
                            method: "GET",
                            credentials: "include",
                        }
                    );
                    const data = await response.json();

                    if (!response.ok) {
                        console.error(
                            "Erreur de chargement des contacts" + data
                        );
                    } else {
                        setListContactRef(data);
                    }
                } catch (error) {
                    console.error(
                        "Erreur lors de la récupération des contacts",
                        error
                    );
                }
            }
        };

        prepareListContactByEnt();
        setNouvelleOffre((prevState) => ({
            ...prevState, // Conservez les autres propriétés de l'objet
            contactId: "", // Mettez à jour uniquement `contactId`
        }));
    }, [nouvelleOffre.entrepriseId]);

    useEffect(() => {
        if (selectedForm === "form2" && nouvelleOffre.entrepriseId === "") {
            setSelectedTypeForm("entreprise");
        } else if (
            selectedForm === "form2" &&
            nouvelleOffre.entrepriseId !== "" &&
            nouvelleOffre.contactId === ""
        ) {
            setSelectedTypeForm("contact");
        } else if (
            selectedForm === "form2" &&
            nouvelleOffre.entrepriseId !== "" &&
            nouvelleOffre.contactId !== ""
        ) {
            setSelectedTypeForm("infosEnreg");
        } else {
            setSelectedTypeForm("");
        }
    }, [
        selectedForm,
        selectedTypeForm,
        nouvelleOffre.entrepriseId,
        nouvelleOffre.contactId,
    ]);

  

    const handleUpdateOffre = async (content, data) => {
        try {           
            const formData = new FormData();
            formData.append("content", content);
            formData.append("data", data);
            formData.append("projet_id", dataProjet.id);
            for (let i = 0; i < filesPO.length; i++) {
                formData.append("files[]", filesPO[i]); // attention au '[]'
            }
            formData.append(
                "montantOG",
                montantOG !== 0 ? String(montantOG) : null
            );
            //  ne sert que pour la dateEtape
            formData.append("targetId", null);


            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(`${apiUrl}/api/admin/projet/update`, {
                method: "POST",
                credentials: "include",
                body: formData,
            });
            const dataResponse = await response.json();
            // console.log(deletedEntreprise.status);

            if (!response.ok) {
                console.error("Erreur d'update projet/offre: " + dataResponse.error);
                setMessUpLoad(dataResponse.error)
            } else {
               
                setRefreshFlag((prev) => !prev);
                handleClose(content);
                            
            }
        } catch (error) {
            console.error("Erreur d'update projet/offre", error);
        }
    };

    const handleDeleteOffre = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(`${apiUrl}/api/admin/offre/delete`, {
                method: "DELETE",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    offre_id: selectedOA,
                }),
            });
            const dataResponse = await response.json();

            if (!response.ok) {
                console.log(
                    "Erreur lors de la suppression de l'offre" + dataResponse
                );
            } else {
                setSelectedOA("");
                setRefreshFlag((prev) => !prev);
                handleClose("delete");
            }
        } catch (error) {
            console.log("Erreur lors de la suppression de l'offre", error);
        }
    };

    const handleChange = (content, event) => {
        switch (content) {
            case "updateRef":
                setSelectedReferent(event.target.value);
                break;
            case "updateStatut":
                setSelectedStatut(event.target.value);
                break;
            case "delete":
                setSelectedOA(event.target.value);
                break;
            case "add":
                if (event.target.id === "fileSelector") {
                    setNouvelleOffre((prevState) => ({
                        ...prevState, // Conservez les autres propriétés de l'objet
                        files: [
                            ...prevState.files,
                            ...Array.from(event.target.files), //destructuration du tableau formé à partir de event.target.files
                        ],
                    }));
                } else if (event.target.id === "nom")
                    setNouvelleOffre((prevState) => ({
                        ...prevState, // Conservez les autres propriétés de l'objet
                        nom: event.target.value,
                    }));
                else if (event.target.id === "dateEtape")
                    setNouvelleOffre((prevState) => ({
                        ...prevState, // Conservez les autres propriétés de l'objet
                        dateEtape: event.target.value,
                    }));
                else if (event.target.id === "selectEnt2") {
                    setNouvelleOffre((prevState) => ({
                        ...prevState, // Conservez les autres propriétés de l'objet
                        entrepriseId: event.target.value,
                        entrepriseNom:
                            event.target.options[event.target.selectedIndex]
                                .text,
                    }));
                } else if (event.target.id === "selectContactRef")
                    setNouvelleOffre((prevState) => ({
                        ...prevState, // Conservez les autres propriétés de l'objet
                        contactId: event.target.value, // Mettez à jour uniquement `contactId`
                    }));
                else if (event.target.id === "montant") {
                    setNouvelleOffre((prevState) => ({
                        ...prevState, // Conservez les autres propriétés de l'objet
                        montant: event.target.value,
                    }));
                }

                break;
            default:
                break;
        }
    };

    const removeFile = (index) => {
        setNouvelleOffre((prevState) => ({
            ...prevState,
            files: prevState.files.filter((_, i) => i !== index), // Supprime l'élément à l'index donné
        }));
    };
    const removeFilePO = (index) => {
       setFilesPO((prevState) => prevState.filter((_, i) => i !== index));
    };

    const handleChangeForm = (event) => {
        setSelectedForm(event.target.value);
    };

    const handleChangeEntreprise = (event) => {
        const { name, value } = event.target;
        setDataEntreprise((prevData) => ({
            ...prevData,
            [name]: value || "",
        }));
    };

    const handleChangeContact = (event) => {
        const { name, value } = event.target;
        setDataContact((prevData) => ({
            ...prevData,
            [name]: value || "",
        }));
    };

    // upload création d'une offre
    const handleUpload = async () => {
        const formData = new FormData();
        nouvelleOffre.files.forEach((file, index) => {
            formData.append(`files[${index}]`, file); // On utilise "files[]" pour indiquer un tableau
        });
        formData.append("nom", nouvelleOffre.nom);
        formData.append("type", selectedForm);
        formData.append("montant", nouvelleOffre.montant);
        formData.append("dateEtape", nouvelleOffre.dateEtape);
        formData.append("entrepriseId", nouvelleOffre.entrepriseId);
        formData.append("contactId", nouvelleOffre.contactId);

        try {
            const apiUrl = process.env.REACT_APP_API_URL;

            const url = new URL(`${apiUrl}/api/admin/createOffre`);
            const response = await fetch(url, {
                method: "POST",
                credentials: "include",
                body: formData, // Envoi du FormData
            });

            const data = await response.json();
            if (!response.ok) {
                console.error(data.error);
                setMessUpLoad(data.message);
                
            } else {
                
                handleClose("add");
                setRefreshFlag(true);
                
            }
        } catch (error) {
            console.error("Erreur:", error);
        }
        // }
    };

    // Création de l'entreprise/ du contact
    const handleAdd = async (content) => {
        setMessageError("");
        let formData = null;
        if (content === "entreprise") {
            formData = FormdataEnt();
        } else if (content === "contact") {
            formData = FormdataContact();
        }
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(
                `${apiUrl}/api/admin/${content}/create`,
                {
                    method: "POST",
                    credentials: "include",
                    body: formData, // Envoi du FormData
                }
            );

            const data = await response.json();
            if (!response.ok) {
                //  console.log(data.message);
                setMessageError(data.message);
            } else {
                if (content === "entreprise") {
                    setNouvelleOffre((prevData) => ({
                        ...prevData,
                        entrepriseId: data.id || "",
                        entrepriseNom: dataEntreprise.nom,
                    }));
                    // rafraichit la liste des entreprises si une nouvelle ent a été créée.... (au cas où quelqu'un clique sur les boutons radios plusieurs fois)
                    prepareListEntreprise();
                } else if (content === "contact") {
                    setNouvelleOffre((prevData) => ({
                        ...prevData,
                        contactId: data.id || "",
                    }));
                }
            }
        } catch (error) {
            console.error("Erreur:", error);
        }
    };

    const FormdataEnt = () => {
        const formData = new FormData();
        formData.append("antenne", dataEntreprise.antenne_enea);
        formData.append("nom", dataEntreprise.nom);
        formData.append("cat", dataEntreprise.cat);

        formData.append("adresse", dataEntreprise.adresse);
        formData.append("CP", dataEntreprise.CP);
        formData.append("ville", dataEntreprise.ville);
        return formData;
    };

    const FormdataContact = () => {
        const formData = new FormData();
        formData.append("antenne", dataContact.antenne_enea);
        formData.append("sexe", dataContact.sexe);
        formData.append("nom", dataContact.nom);
        formData.append("prenom", dataContact.prenom);
        formData.append("entrepriseId", nouvelleOffre.entrepriseId);
        formData.append("fonction", dataContact.fonction);
        formData.append("tel1", dataContact.tel1);
        formData.append("tel2", dataContact.tel2);
        formData.append("mail1", dataContact.mail1);
        formData.append("mail2", dataContact.mail2);
        formData.append("adresse", dataContact.adresse);
        formData.append("CP", dataContact.CP);
        formData.append("ville", dataContact.ville);
        return formData;
    };

    // Modification du montant et ajout du Bon de Commande (Purchase Order) quand l'offre passe au statut "Gagnée"
    const [montantOG, setMontantOG] = useState(0);
    const [filesPO, setFilesPO] = useState([]);

      useEffect(() => {
          setMessUpLoad("");
      }, [nouvelleOffre.files, filesPO]);

    return (
        <Modal>
            <ModalContainer content={content}>
                {content === "updateReferent" && (
                    <>
                        <h2>Changer le contact référent pour l'offre: </h2>
                        <p>{dataProjet.nom}</p>
                        <select
                            name="selectRef"
                            id="selectRef"
                            value={selectedReferent}
                            onChange={(event) =>
                                handleChange("updateRef", event)
                            }
                        >
                            {listContact.map((element, index) => (
                                <option key={index} value={element.id}>
                                    {element.identity}
                                </option>
                            ))}
                        </select>
                    </>
                )}
                {content === "updateStatut" && (
                    <>
                        <h2>Changer le statut de l'offre:</h2>
                        <p>{dataProjet.nom}</p>
                        <select
                            name="selectStatut"
                            id="selectStatut"
                            value={selectedStatut}
                            onChange={(event) =>
                                handleChange("updateStatut", event)
                            }
                        >
                            {Object.values(statutLabels).map((element) => (
                                <option
                                    key={element.statut}
                                    value={element.statut}
                                >
                                    {element.label}
                                </option>
                            ))}
                        </select>
                        {type === "offre" && selectedStatut === "OG" && (
                            <div className="containerOG">
                                <label
                                    htmlFor="montantOG"
                                    className="yellow labelOG"
                                >
                                    Montant de l'Offre Gagnée (XOF)
                                </label>
                                <input
                                    type="number"
                                    step="0.01"
                                    name="montantOG"
                                    id="montantOG"
                                    value={montantOG}
                                    onChange={(event) =>
                                        setMontantOG(
                                            parseFloat(event.target.value)
                                        )
                                    }
                                />
                                <label
                                    htmlFor="fileSelector"
                                    className="yellow labelOG"
                                >
                                    Téléversement du bon de commande (Purchase
                                    Order)
                                </label>
                                <label
                                    htmlFor="fileSelector"
                                    className="fileSelector"
                                >
                                    📂 Ajouter des documents
                                </label>
                                <input
                                    type="file"
                                    name="fileSelector"
                                    id="fileSelector"
                                    // permet la sélection de plusieurs fichiers d'un coup (multiple)
                                    onChange={(event) => {
                                        const selectedFiles = Array.from(
                                            event.target.files
                                        );
                                        setFilesPO((prevState) => [
                                            ...prevState,
                                            ...selectedFiles,
                                        ]);
                                    }}
                                    accept="application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                    multiple
                                    hidden
                                />
                                <div className="doc">
                                    <span className="yellow listFiles">
                                        {filesPO.length !== 0
                                            ? filesPO.map((file, index) => {
                                                  return (
                                                      <span key={index}>
                                                          {file.name}{" "}
                                                          <img
                                                              src={removeCross}
                                                              alt="removeCross"
                                                              onClick={() =>
                                                                  removeFilePO(
                                                                      index
                                                                  )
                                                              }
                                                          />
                                                      </span>
                                                  );
                                              })
                                            : "Pas de fichiers sélectionés"}
                                    </span>
                                </div>
                            </div>
                        )}
                    </>
                )}

                {content === "add" && (
                    <Formulaire>
                        <h2>Création d'une nouvelle offre</h2>
                        <div className="rowMP">
                            <label htmlFor="nom">Nom de l'offre * </label>
                            <input
                                type="text"
                                name="nom"
                                id="nom"
                                value={nouvelleOffre.nom}
                                onChange={(event) => handleChange("add", event)}
                            />
                            <label htmlFor="">Documents *</label>
                            <label
                                htmlFor="fileSelector"
                                className="fileSelector"
                            >
                                📂 Ajouter des documents
                            </label>
                            <input
                                type="file"
                                id="fileSelector"
                                onChange={(event) => handleChange("add", event)}
                                accept="application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                multiple
                                hidden
                            />
                        </div>

                        <div className="doc">
                            <span className="yellow listFiles">
                                {nouvelleOffre.files.length !== 0
                                    ? nouvelleOffre.files.map((file, index) => {
                                          return (
                                              <span>
                                                  {file.name}{" "}
                                                  <img
                                                      src={removeCross}
                                                      alt="removeCross"
                                                      onClick={() =>
                                                          removeFile(index)
                                                      }
                                                  />
                                              </span>
                                          );
                                      })
                                    : "Pas de fichiers sélectionés"}
                            </span>
                        </div>

                        <div className="rowMP">
                            <label htmlFor="montant">
                                Montant de l'offre (FCFA) *
                            </label>
                            <input
                                type="number"
                                name="montant"
                                id="montant"
                                step="0.01"
                                value={nouvelleOffre.montant}
                                onChange={(event) => handleChange("add", event)}
                            />

                            <label htmlFor="dateEtape">
                                Date de soumission
                            </label>
                            <input
                                type="date"
                                name="dateEtape"
                                id="dateEtape"
                                value={nouvelleOffre.dateEtape}
                                onChange={(event) => handleChange("add", event)}
                            />
                        </div>
                        <div className="rowMP radio">
                            <div>
                                <input
                                    type="radio"
                                    name="choixForm"
                                    id="radioEE"
                                    value="form1"
                                    checked={selectedForm === "form1"}
                                    onChange={handleChangeForm}
                                />
                                <label htmlFor="radioEE">
                                    Entreprise déja enregistrée?
                                </label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    name="choixForm"
                                    id="radioNE"
                                    value="form2"
                                    checked={selectedForm === "form2"}
                                    onChange={handleChangeForm}
                                />
                                <label htmlFor="radioNE">
                                    Nouvelle entreprise? / Nouveau contact?{" "}
                                    (après sélection de l'entreprise)
                                </label>
                            </div>
                        </div>
                        <hr />
                        {selectedForm === "form1" && (
                            <>
                                <div className="rowMP">
                                    <label htmlFor="selectEnt2">
                                        Sélectionner l'entreprise:
                                    </label>
                                    <select
                                        name="selectEnt2"
                                        id="selectEnt2"
                                        value={nouvelleOffre.entrepriseId}
                                        onChange={(event) =>
                                            handleChange("add", event)
                                        }
                                    >
                                        <option value="">Entreprise?</option>
                                        {listEntreprise.map(
                                            (element, index) => (
                                                <option
                                                    key={index}
                                                    value={element.id}
                                                >
                                                    {element.nom}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </div>
                                <div className="rowMP">
                                    <label htmlFor="selectContactRef">
                                        Sélectionner le contact référent:
                                    </label>
                                    <select
                                        name="selectContactRef"
                                        id="selectContactRef"
                                        value={nouvelleOffre.contactId}
                                        onChange={(event) =>
                                            handleChange("add", event)
                                        }
                                    >
                                        <option value="">Contact?</option>
                                        {listContactRef.map(
                                            (element, index) => (
                                                <option
                                                    key={index}
                                                    value={element.id}
                                                >
                                                    {element.identity}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </div>
                            </>
                        )}

                        {selectedForm === "form2" && (
                            <div className="form2">
                                {selectedTypeForm === "entreprise" && (
                                    <div className="formCard FormEntreprise">
                                        <h2>
                                            Création de l'Entreprise Cliente
                                        </h2>
                                        <FormEntreprise
                                            dataEntreprise={dataEntreprise}
                                            handleChange={
                                                handleChangeEntreprise
                                            }
                                            messageError={messageError}
                                        />

                                        {nouvelleOffre.entrepriseId === "" && (
                                            <ChoiceButtons>
                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        handleAdd("entreprise")
                                                    }
                                                    className="btnModal btnModal1"
                                                >
                                                    Créer
                                                </button>
                                            </ChoiceButtons>
                                        )}
                                    </div>
                                )}
                                {selectedTypeForm === "contact" && (
                                    <div className="formCard FormContact">
                                        <h2>
                                            Création d'un nouveau contact
                                            (Référent de l'offre)
                                        </h2>
                                        <FormContact
                                            dataContact={dataContact}
                                            handleChange={handleChangeContact}
                                            messageError={messageError}
                                        />
                                        {nouvelleOffre.contactId === "" && (
                                            <ChoiceButtons>
                                                <button
                                                    // ici type button est important par défaut c'est un type submit qui envoyait le formulaire global!!
                                                    type="button"
                                                    onClick={() =>
                                                        handleAdd("contact")
                                                    }
                                                    className="btnModal btnModal1"
                                                >
                                                    Créer
                                                </button>
                                            </ChoiceButtons>
                                        )}
                                    </div>
                                )}
                                {selectedTypeForm === "infosEnreg" && (
                                    <div>
                                        <p>
                                            Nom de l'entreprise:{" "}
                                            <span className="yellow">
                                                {nouvelleOffre.entrepriseNom}
                                            </span>
                                        </p>
                                        <p>
                                            Contact référent:{" "}
                                            <span className="yellow">
                                                {dataContact.sexe === "M"
                                                    ? "Mr"
                                                    : "Mme"}{" "}
                                                {dataContact.nom}{" "}
                                                {dataContact.prenom}
                                            </span>
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}
                    </Formulaire>
                )}

                {content === "delete" && (
                    <>
                        <h2>Suppression d'une offre annulée</h2>

                        <select
                            name="selectOA"
                            id="selectOA"
                            value={selectedOA}
                            onChange={(event) => handleChange("delete", event)}
                        >
                            <option value="" disabled>
                                --Choix de l'offre à supprimer--
                            </option>
                            {listOA.map((element, index) => (
                                <option key={index} value={element.id}>
                                    Entreprise: {element.entreprise} - Numéro
                                    d'offre: {element.numeroOffre}
                                </option>
                            ))}
                        </select>
                        <h3 className="red">
                            Attention cette action est irréversible! <br />
                            Les documents associés à cette offre ne seront plus
                            accessibles.
                        </h3>
                    </>
                )}

                <ChoiceButtons>
                    {content === "updateReferent" && (
                        <button
                            onClick={() =>
                                handleUpdateOffre(
                                    "updateReferent",
                                    selectedReferent
                                )
                            }
                            className="btnModal btnModal1"
                        >
                            Valider
                        </button>
                    )}
                    {content === "updateStatut" &&
                        !(
                            type === "offre" &&
                            selectedStatut === "OG" &&
                            (filesPO.length === 0 ||
                                montantOG === 0 ||
                                isNaN(montantOG))
                        ) && (
                            <button
                                onClick={() =>
                                    handleUpdateOffre(
                                        "updateStatut",
                                        selectedStatut
                                    )
                                }
                                className="btnModal btnModal1"
                            >
                                Valider
                            </button>
                        )}
                    {content === "delete" && selectedOA !== "" && (
                        <button
                            onClick={handleDeleteOffre}
                            className="btnModal btnModal1"
                        >
                            Valider
                        </button>
                    )}
                    {content === "add" &&
                        nouvelleOffre.entrepriseId !== "" &&
                        nouvelleOffre.contactId !== "" &&
                        nouvelleOffre.nom !== "" &&
                        nouvelleOffre.files.length !== 0 &&
                        nouvelleOffre.montant !== "" && (
                            <button
                                onClick={handleUpload}
                                className="btnModal btnModal1"
                            >
                                Valider
                            </button>
                        )}

                    {/* bouton générique "Annuler" pour la fermeture de toutes les modales sans changements. */}
                    <button
                        onClick={() => handleClose(content)}
                        className="btnModal btnModal2"
                    >
                        Annuler
                    </button>

                    {/* {content === "add" && (
                        <button
                            onClick={() => handleClose("add")}
                            className="btnModal btnModal2"
                        >
                            Annuler
                        </button>
                    )}  */}
                </ChoiceButtons>
                <p className="messUpLoad">{messUpLoad}</p>
            </ModalContainer>
        </Modal>
    );
};

export default ModalProjet;
